<ng-container *ngIf="data?.length; else emptyTable">
    <div class="data-block">
        <p-table
            [value]="data"
            [scrollable]="true"
            scrollHeight="flex"
            selectionMode="single"
            (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th>GTIN</th>
                        <th i18n>Наименование</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [pSelectableRow]="product">
                        <td>{{ product?.gtin }}</td>
                        <td>{{ product?.name }}</td>
                    </tr>
                </ng-template>
                <ng-template *ngIf="data?.length > 1" pTemplate="summary">
                    <div i18n class="flex align-items-center justify-content-between">
                        Уточните текст поиска.
                    </div>
                </ng-template>
        </p-table>
    </div>
</ng-container>
<ng-template #emptyTable>
    <div class="empty-table">
        <span>
            <ng-container *ngIf="!notFound; else notFoundData">
                <ng-container i18n>Для поиска введите GTIN или наименование</ng-container>
            </ng-container>
            <ng-template #notFoundData i18n>
                По заданным параметрам товар не найден
            </ng-template>
        </span>
    </div>
</ng-template>
